/// <reference types="pixi.js" />
namespace pixi_picture {
	(PIXI as any).picture = pixi_picture;
}
